import React from "react"
import { makeStyles, styled } from "@mui/styles"
import { Box, ClickAwayListener, IconButton, Tooltip, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

const ConformityTooltip = ({ children }) => {
  const [open, setOpen] = React.useState(false)
  const classes = useStyles()

  const handleToggle = () => setOpen((v) => !v)
  const handleClose = () => setOpen(false)

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    ["& .MuiTooltip-tooltip"]: {
      marginTop: theme.spacing(1) + " !important",
      marginRight: "10px !important",
      backgroundColor: "#000",
      color: "#fff",
      padding: theme.spacing(2),
      borderRadius: 12,
      boxShadow: theme.shadows[6],
      maxWidth: 467,
    },
  }))

  const titleContent = (
    <ClickAwayListener onClickAway={handleClose}>
      <Box sx={{ position: "relative" }}>
        <IconButton aria-label="Fermer" onClick={handleClose} size="small" sx={{ position: "absolute", top: 2, right: 2, p: 0, color: "#fff", fontSize: "16px" }}>
          <CloseIcon size="24px" />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 2 }}>
          Règle de conformité
        </Typography>
        <table className={classes.conformityTable}>
          <thead>
            <tr>
              <td >O2 résiduel</td>
              <td >CO2</td>
              <td >N2</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td >de 0,0 % à 1,0 %</td>
              <td >de 40 % à 51 %</td>
              <td >reste de la composition</td>
            </tr>
          </tbody>
        </table>
        <ul style={{ margin: "16px 0 0", paddingLeft: 26 }}>
          <li><span style={{ fontWeight: 500 }}>En cas de non-conformité : </span>se référer à l&apos;affichage 25 <br />mise sous atmosphère protectrice</li>
        </ul>
      </Box>
    </ClickAwayListener>
  )

  return (
    <StyledTooltip
      open={open}
      onClose={handleClose}
      title={titleContent}
      placement="bottom-end"
      disableFocusListener
      disableHoverListener
      disableTouchListener
    >
      {React.cloneElement(children, { onClick: handleToggle })}
    </StyledTooltip>
  )
}

export default ConformityTooltip

const useStyles = makeStyles(() => ({
  conformityTable: {
    width: "100%",
    borderRadius: "8px",
    borderCollapse: "separate",
    border: "1px solid #fff",
    borderSpacing: 0,
    overflow: "hidden",
    "& th, & td": {
      padding: "12px"
    },
    "& tbody td": {
      borderTop: "1px solid #fff",
    },
    "& td:not(:last-child)": {
      borderRight: "1px solid #fff",
    }
  },
}))